var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('page-header',{attrs:{"root-location":{ name: _vm.$routes.ProjectContentRealEstate, params: _vm.$route.params }}}),_c('listing-manual-entry-card',{attrs:{"bot":_vm.bot}}),_c('real-estate-manual-listings-list-card',{attrs:{"bot":_vm.bot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }